module["exports"] = [
  "And",
  "Ara",
  "Ast",
  "Bal",
  "Can",
  "Cbr",
  "Man",
  "Leo",
  "Cat",
  "Com",
  "Ext",
  "Gal",
  "Rio",
  "Mad",
  "Nav",
  "Vas",
  "Mur"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/state_abbr.js
// module id = 1357
// module chunks = 0